export const NAME = 'cuttingMachines';